import {applyMiddleware, createStore} from "redux";
import thunk from "redux-thunk";
import rootReducer from '../reducers/index';

const createStoreWithMW = applyMiddleware(thunk)(createStore);
const store = createStoreWithMW((rootReducer));

export default store;